import { AppScreen } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import { useAtom } from 'jotai/index';

import { itemColumnsAtom } from './atoms/itemFilterAtoms';
import ItemCategories from './components/ItemCategories';
import ItemGrid from './components/ItemGrid';
import ItemHeader from './components/ItemHeader';
import ShopItemContext from './context/ShopItemContext';

interface Params {
    shopId: string;
    categoryId?: string;
    type: 'ALL' | 'MY_MENU',
}

declare module '@stackflow/config' {
    interface Register {
        ItemsActivity: Params;
    }
}

const ItemsActivity: ActivityComponentType<'ItemsActivity'> = ({ params }) => {
    const { shopId, categoryId } = params;
    const [columns, setColumns] = useAtom(itemColumnsAtom);
    return (
        <AppScreen>
            <ShopItemContext value={{ shopId, categoryId }}>
                <ItemHeader shopId={shopId}/>
                <ItemCategories/>
                <ItemGrid columns={columns}/>
            </ShopItemContext>
        </AppScreen>
    );
};

export default ItemsActivity;
